import Vue from 'vue'
import autosize from 'autosize' // http://www.jacklmoore.com/autosize/

const getTextarea = el => {
  return el.tagName === 'TEXTAREA' ? el : el.getElementsByTagName('textarea')[0]
}

Vue.directive('autosize', {
  bind(el) {
    autosize(getTextarea(el))
  },
  inserted(el) {
    el = getTextarea(el)
    if (el.value) autosize.update(el)
  },
  update(el) {
    el = getTextarea(el)
    if (el.value === '') autosize.update(el)
  },
  unbind(el) {
    el = getTextarea(el)
    autosize.destroy(el)
  }
})
